(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('VideoTypeIbqDeleteController',VideoTypeIbqDeleteController);

    VideoTypeIbqDeleteController.$inject = ['$uibModalInstance', 'entity', 'VideoType'];

    function VideoTypeIbqDeleteController($uibModalInstance, entity, VideoType) {
        var vm = this;

        vm.videoType = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VideoType.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
